import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faChartLine,
    faChevronCircleUp,
    faChevronCircleDown,
    faCogs,
} from '@fortawesome/pro-duotone-svg-icons'
import Divider from '@mui/material/Divider'
import List from '@mui/material/List'

import { LinkMenuItem } from './LinkMenuItem'
import { HeadMenuItem } from './HeadMenuItem'
import { AdminMenuItems } from '../model/AdminMenuItems'
import { AdminMainMenuProps } from '../model/types'
import { useAdminPermissions } from '../hooks/useAdminPermissions'

export const AdminMainMenu: React.FC<AdminMainMenuProps> = ({
    kedo,
    close,
}) => {
    const [displayAdminSettings, setDisplayAdminSettings] =
        useState<boolean>(false)

    const { hasAdminAccess } = useAdminPermissions(kedo)

    return (
        <nav className="dropdown" aria-label="Admin Navigation">
            <List sx={{ p: 0 }}>
                <LinkMenuItem
                    className={'menu-item menu-head-item'}
                    onClick={close}
                    linkClassName={'dashboard'}
                    key={'dashboard'}
                    exact
                    to={`/`}
                >
                    <FontAwesomeIcon
                        icon={faChartLine}
                        style={{ marginRight: '4px' }}
                    />{' '}
                    &nbsp;{kedo.t('Dashboard')}
                </LinkMenuItem>
                <Divider component="li" aria-hidden="true" />

                {hasAdminAccess() ? (
                    <>
                        <HeadMenuItem
                            className={'menu-item admin'}
                            label={kedo.t('Admin settings')}
                            dataCy="head-menu-item"
                            dataCyId="admin"
                            icon={faCogs}
                            toggleIcon={{
                                open: faChevronCircleUp,
                                closed: faChevronCircleDown,
                            }}
                            isOpen={displayAdminSettings}
                            onToggle={() =>
                                setDisplayAdminSettings((prev) => !prev)
                            }
                        />
                        <Divider component="li" aria-hidden="true" />
                    </>
                ) : null}
            </List>
            {displayAdminSettings ? (
                <List sx={{ p: 0 }} onClick={() => window.scrollTo(0, 0)}>
                    {AdminMenuItems.map(
                        (item) =>
                            kedo.hasPermissionFor(item.permission) && (
                                <LinkMenuItem
                                    key={item.id}
                                    to={item.path}
                                    onClick={close}
                                    className="MainMenuLink link-item"
                                    linkClassName=""
                                >
                                    {item.icon && (
                                        <FontAwesomeIcon icon={item.icon} />
                                    )}{' '}
                                    {kedo.t(item.label)}
                                </LinkMenuItem>
                            )
                    )}
                    {kedo.isAdmin() ? (
                        <LinkMenuItem
                            key="messagequeue"
                            to="/messagequeue"
                            onClick={close}
                            className="MainMenuLink link-item"
                            linkClassName=""
                        >
                            {kedo.t('Message queue')}
                        </LinkMenuItem>
                    ) : null}
                </List>
            ) : null}
        </nav>
    )
}
